import React from 'react';
import { Modal } from '../ui/Modal.js';
import { useDataContext } from '../../context/data.js';
import translations from '../../constants/translations.json';

const PromoPopupModal = ({ restaurant, isOpen, onClose }) => {
  const { language } = useDataContext();

  if (!restaurant?.PromoPopUpEnabled) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="text-center">
        <div className="space-y-4">
          <div className="space-y-2">
            <h1 className="font-bold text-base sm:text-lg">{restaurant?.PromoHeader || 'N/A'}</h1>
            <p className="text-sm sm:text-base">{restaurant?.PromoMessage || 'N/A'}</p>
          </div>
          {restaurant?.PromoImage && (
            <img
              src={restaurant?.PromoImage}
              alt={`promo`}
              className="w-full max-w-[400px] lg:max-w-[500px] object-cover"
            />
          )}
        </div>

        <button
          className="mt-6 bg-primary hover:bg-secondary text-white font-bold w-full sm:w-auto px-20 py-3 rounded-full transition-colors"
          onClick={onClose}
        >
          {translations[language]?.close}
        </button>
      </div>
    </Modal>
  );
};

export default PromoPopupModal;
